import script from "./myappointment.vue?vue&type=script&setup=true&lang=js"
export * from "./myappointment.vue?vue&type=script&setup=true&lang=js"

import "./myappointment.vue?vue&type=style&index=0&id=06e810a8&scope=true&lang=css"

const __exports__ = script;

export default __exports__